import React from 'react';
import { TargetIcon, CheckCircleIcon } from 'lucide-react';
const outdoorRangeRules = ['All shooting must be directed into the berms/backstops.', 'No shooting at trees, posts, or any structure.', 'Targets must be placed so all rounds impact the berm.', 'Ground-level targets are not permitted — use target stands.', 'Steel targets must be approved by the club and placed at proper distances.', 'No aerial shooting (shooting at thrown objects).', 'Observe all posted range-specific rules at each outdoor range.'];
export function OutdoorRangeRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2912">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2913">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2914">
          Outdoor Rifle & Pistol Ranges
        </h2>
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2915">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-2916">
            <TargetIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-2917" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2918">
              Outdoor Range Specific Rules
            </h3>
          </div>
          <div className="p-6 md:p-8 space-y-4" data-id="element-2919">
            {outdoorRangeRules.map((rule, index) => <div key={index} className="flex items-start gap-3" data-id="element-2920">
                <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#1e3d2f'
            }} data-id="element-2921" />
                <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2922">
                  {rule}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}